import { PlusOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import React from 'react'
import { MasterDataUploadDownloadButtons } from '../../../../components/UploadDownload/MasterDataUploadDownloadButtons'

interface ActionButtonsProps {
  entityType: string
  onCreateClick: () => void
  onRefresh: () => void
}

/**
 * Action buttons component for MasterDataGrid toolbar
 */
export const ActionButtons: React.FC<ActionButtonsProps> = ({
  entityType,
  onCreateClick,
  onRefresh,
}) => {
  return [
    <MasterDataUploadDownloadButtons
      key='upload-download'
      entityType={entityType}
      refreshCallback={onRefresh}
    />,
    <Button
      key='create'
      type='primary'
      icon={<PlusOutlined />}
      onClick={onCreateClick}
    >
      Add {entityType.charAt(0).toUpperCase() + entityType.slice(1)}
    </Button>,
  ]
}
